import React from 'react';
import { Divider, List, ListItem } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { completedRoutes } from '../../../common/constants';
import { useTranslation } from 'react-i18next';
import './desktop-side-bar.scss';

function DesktopSideBar(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = history.location;
  const { admin } = props;

  const navBarLinksMapping = {
    tasks: completedRoutes.userTasks,
    myActivity: completedRoutes.userActivity,
    rules: admin ? completedRoutes.adminRules : completedRoutes.userRules,
    forCompanies: admin ? completedRoutes.adminForCompanies : completedRoutes.userForCompanies,
    myPlaces: completedRoutes.adminPlaces,
    userPlaces: completedRoutes.userPlaces,
    userPayment: completedRoutes.userPayment,
  };

  const geActiveLink = () => {
    switch (pathname) {
      case navBarLinksMapping.myActivity:
        return 'myActivity';
      case navBarLinksMapping.rules:
        return 'rules';
      case navBarLinksMapping.forCompanies:
        return 'forCompanies';
      case navBarLinksMapping.myPlaces:
        return 'places';
      case navBarLinksMapping.userPayment:
        return 'userPayment';
      case navBarLinksMapping.userPlaces:
        return 'userPlaces';
      default:
        return admin ? 'places' : 'tasks';
    }
  };

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="desktop-side-bar-cnt">
      <List classes={{ root: 'nav-bar' }}>
        <ListItem>
          {!admin && pathname !== navBarLinksMapping.tasks && pathname !== navBarLinksMapping.myPlaces &&
          <div className="go-back" onClick={handleGoBack}>
            <div className="arrow" />
            <div>{t('common.back')}</div>
          </div>
          }
        </ListItem>
        {!admin ?
          <>
            <ListItem>
              <Link to={navBarLinksMapping.tasks}
                    className={`link ${geActiveLink() === 'tasks' ? 'active' : ''}`}>
                {t('navBar.tasks')}
              </Link>
            </ListItem>
            <ListItem>
              <Link to={navBarLinksMapping.myActivity}
                    className={`link ${geActiveLink() === 'myActivity' ? 'active' : ''}`}>
                {t('navBar.myActivity')}
              </Link>
            </ListItem>
            <ListItem>
              <Link to={navBarLinksMapping.userPlaces}
                    className={`link ${geActiveLink() === 'userPlaces' ? 'active' : ''}`}>
                {t('navBar.userPlaces')}
              </Link>
            </ListItem>
            <ListItem>
              <Link to={navBarLinksMapping.userPayment}
                    className={`link ${geActiveLink() === 'userPayment' ? 'active' : ''}`}>
                <span className="green">{t('navBar.userPayment')}</span>
              </Link>
            </ListItem>
            <Divider />
            <br />
            <ListItem>
              <Link to={navBarLinksMapping.rules}
                    className={`link ${geActiveLink() === 'rules' ? 'active' : ''}`}>
                {t('navBar.rules')}
              </Link>
            </ListItem>
            <ListItem>
              <Link to={navBarLinksMapping.forCompanies}
                    className={`link ${geActiveLink() === 'forCompanies' ? 'active' : ''}`}>
                {t('navBar.forCompanies')}
              </Link>
            </ListItem>
          </>
          :
          <>
            <ListItem>
              <Link to={navBarLinksMapping.myPlaces}
                    className={`link ${geActiveLink() === 'places' ? 'active' : ''}`}
              >
                {t('navBar.myPlaces')}
              </Link>
            </ListItem>
            <ListItem>
              <Link to={navBarLinksMapping.rules}
                    className={`link ${geActiveLink() === 'rules' ? 'active' : ''}`}
              >
                {t('navBar.rules')}
              </Link>
            </ListItem>
            <ListItem>
              <Link to={navBarLinksMapping.forCompanies}
                    className={`link ${geActiveLink() === 'forCompanies' ? 'active' : ''}`}
              >
                {t('navBar.forCompanies')}
              </Link>
            </ListItem>
          </>
        }
      </List>
    </div>
  );
}

export default DesktopSideBar;
